import client from "../client"

export const getUserPushConfig = async () => {
  const response = await client.get("/users/push/config")

  return response.data
}
